import { render, staticRenderFns } from "./CartMenuIcon.vue?vue&type=template&id=2fd68ab6&scoped=true&"
import script from "./CartMenuIcon.vue?vue&type=script&lang=js&"
export * from "./CartMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd68ab6",
  null
  
)

export default component.exports